<template>
    <v-card v-if="item">
            
            <v-card-title class="secondary white--text text-h5">{{$t('accessRights.generateLink.title')}}</v-card-title>
            <v-card-text class="mt-3">
                
                <p>{{$t('accessRights.generateLink.text', { name: item.name, entity: entity.toLowerCase() })}}</p>
                <p>{{$t('accessRights.enterEmails')}}</p>
                <v-form ref="emailForm" lazy-validation>
                <v-text-field id="pfid1618819011" 
                v-model="email" 
                type="email" 
                prepend-icon="$mailing" 
                :label="$t('common.emailAddress')" 
                append-outer-icon="$add"
                :rules="emailRules" 
                @click:append-outer="addEmail"/>
                </v-form>
                <label class="v-label"><v-icon left>$edit</v-icon> {{$t('accessRights.editors')}}</label>
                <v-chip-group id="pfid1618819090" 
                >
                <v-chip disabled v-if="!recipients.length">{{$t('common.empty')}}</v-chip>
                <v-chip
                v-for="(r,i) in recipients"
                :key="`${r}${i}`"
                close
                @click:close="removeEmail(r)"
                >
                {{ r }}
                </v-chip>
          </v-chip-group>
                <v-textarea id="linkTextarea" readonly v-model="link" prepend-icon="$shareAccess" :label="$t('common.shareLink')"/>
                
            </v-card-text>
            <v-card-actions>
                <v-btn id="pfid1618819050" text color="primary" @click="getToken" :disabled="!recipients.length" :loading="loading"><v-icon left>$shareAccess</v-icon>{{$t('common.getLink')}}</v-btn>
                <v-btn id="pfid1618819056" text color="primary" @click="copyLink" :disabled="!token"><v-icon left>$copy</v-icon>{{$t('common.copyLink')}}</v-btn>
                <v-btn id="pfid1618819061" text color="primary" :href="mailMessage" target="_blank" :disabled="!token"><v-icon left>$send</v-icon>{{$t('common.sendEmail')}}</v-btn>
                <v-btn id="pfid1618819066" text @click="token=null;recipients=[];$emit('close')"><v-icon left>$close</v-icon>{{$t('dialog.close')}}</v-btn>
            </v-card-actions>
            
    </v-card>
    <v-skeleton-loader type="card" v-else />
</template>
<script>

import {mapGetters } from 'vuex';

export default {
    name: 'AccessTokenGenerator',
    data() {
        return {
            recipients: [],
            loading: false,
            email: null,
            emailRules: [
                (v) => !!v || this.$t('form.rules.required'), 
                (v) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || this.$t('form.rules.email')
            ],
            token: null
        }
    },
    props: {endpoint: { type: String, required: true }},
    computed: {
        item() {
            return this.$store.state[this.endpoint].item;
        },
        entity() {
            return this.$store.state[this.endpoint].entity;
        },
        link() {
            if(!this.token) {
                return null;
            }
            return this.baseUrl + '/token/' + this.token;
        },
        mailMessage() {
            if(!this.token) {
                return null;
            }
            // TODO test
            return `mailto:${this.userEmail}?bcc=${this.recipients.join(',')}&subject=${encodeURIComponent(this.$t('accessRights.share.subject'))}&body=${encodeURIComponent(this.$t('accessRights.share.body', { user: this.userEmail, name: this.item.name, entity: this.entity.toLowerCase(), link: this.link}))}`
            //return `mailto:${this.userEmail}?bcc=${this.recipients.join(',')}&subject=DreamROI%20-%20Editor%20invitation&body=%3Chtml%3E%0D%0A%3Cbody%3E%0D%0A%3Cp%3EA%20DreamROI%20user%20${this.userEmail}%20has%20invited%20you%20to%20become%20an%20editor%20for%20the%20${this.item.name}%20${this.entity.toLowerCase()}.%20To%20get%20access%2C%20click%20the%20following%20link%3A%20%3Ca%20href%3D%22${this.link}%22%3ERequest%20access%3C%2Fa%3E.%3C%2Fp%3E%0D%0A%3Cp%3EIf%20you%20don't%20have%20a%20DreamROI%20account%20yet%2C%20you%20can%20create%20one%20after%20clicking%20the%20link.%20Just%20use%20the%20same%20r-mail%20address%20to%20which%20this%20e-mail%20was%20sent.%3C%2Fp%3E%0D%0A%3C%2Fbody%3E%0D%0A%3C%2Fhtml%3E`
        },
        ...mapGetters('auth', { userEmail: 'email' }),
        ...mapGetters('ui', ['baseUrl'])
    },
    methods: {
        addEmail() {
            if(!this.$refs.emailForm.validate()) {
                //console.debug('E-mail is not valid');
                return;
            }
            this.recipients.push(this.email);
            this.email = null;
            this.token = null;
            this.$refs.emailForm.resetValidation();
        },
        removeEmail(e) {
            this.token = null;
            this.recipients.splice(this.recipients.indexOf(e),1);
        },
        getToken() {
            this.loading = true;
            this.$store.dispatch('auth/getAccessToken', { entity: this.entity, id: this.item.id, editors: this.recipients }).then((token) => {
                this.loading = false;
                this.token = token;
            })
        },
        copyLink() {
            //this.$refs.emailForm.reset();
            //this.$refs.emailForm.resetValidation();
            /*
            this.$copyText(this.link).then((e) => {
            this.$store.dispatch('ui/notify', { text: 'Link was copied to clipboard'});
            console.debug(e);
            }, (e) => {
                this.$store.dispatch('ui/notify', { text: 'Unable to copy the link', error: true });
                console.debug(e)
            })
            */
           
           
           try {
                document.getElementById('linkTextarea').select();
                document.execCommand('copy');
                this.$store.dispatch('ui/notify', { text: this.$t('common.linkCopied')});
           } catch(e) {
                this.$store.dispatch('ui/notify', { text: this.$t('common.linkCopyError'), error: true });
                console.error(e)
           }
           
        }
    }
}
</script>